import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["coachSelect", "typeSelect", "capacityChange", "hoursDisplay"]

  connect() {
    console.log("Capacity Event controller connected")
    this.calculateHours()
  }

  updateCapacity() {
    const coachSelect = this.coachSelectTarget
    const selectedOption = coachSelect.options[coachSelect.selectedIndex]
    const eventType = this.typeSelectTarget.value

    console.log("Update capacity triggered", { eventType, selectedOption: selectedOption?.text, capacity: selectedOption?.dataset?.capacity })

    if (eventType === 'leaving' && selectedOption && selectedOption.dataset.capacity) {
      const capacity = parseInt(selectedOption.dataset.capacity, 10)
      if (!isNaN(capacity)) {
        this.capacityChangeTarget.value = -capacity
        console.log("Set capacity to", -capacity)
        this.calculateHours()
      }
    }
  }

  calculateHours() {
    const slots = parseInt(this.capacityChangeTarget.value, 10)
      
    if (isNaN(slots) || slots === 0) {
      this.hoursDisplayTarget.textContent = ""
      return
    }

    const hours = (Math.abs(slots) * 20 / 60).toFixed(1)
    const sign = slots > 0 ? "+" : "-"
    const changeText = slots > 0 ? "increase" : "decrease"

    this.hoursDisplayTarget.textContent = `${sign}${hours} hours (${changeText} of ${Math.abs(slots)} slots)`
  }
}
